// store/api.ts

import {
  AddBulkOrderUser,
  AddProduct,
  AddWalletBalance,
  CouponData,
  CreditActivationData,
  UpdateBrand,
  UpdateInvoiceProps,
  UpdateOrderStatus,
  UpdateSKU,
  UpdateWalletBalance,
} from "@/types/api";

const fetchAPI = async (endpoint: string, options: RequestInit = {}) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_B2B_API_BASE_URL}${endpoint}`,
    {
      headers: { "Content-Type": "application/json" },
      ...options,
    }
  );

  if (!response.ok) {
    throw new Error(`API error: ${response.statusText}`);
  }
  const data = await response.json();

  return data;
};

// API Calls
export const fetchDashboard = () => fetchAPI("/admin/dashboard");
export const fetchCoupons = () => fetchAPI("/coupon/fetch");
export const fetchUserDetail = (userID: number) => fetchAPI(`/user/${userID}`);
export const updateCouponStatusById = (couponId: number) =>
  fetchAPI(`/admin/coupon/${couponId}`);
export const fetchUsers = () => fetchAPI("/admin/users");
export const fetchSubCategory = () => fetchAPI("/subcategories");
export const fetchWalletUsers = () => fetchAPI("/admin/wallet/users");
export const fetchCreditUsers = () => fetchAPI("/admin/credit/users");
export const fetchUsersCart = () => fetchAPI("/admin/cart/users");
export const fetchSKU = () => fetchAPI("/admin/sku");

export const toggleCreditStatus = (userID: number) =>
  fetchAPI(`/credit/toggle/${userID}`);

export const updateSKU = (data: UpdateSKU) =>
  fetchAPI("/admin/update/sku", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const fetchBrands = () => fetchAPI("/admin/brand");

export const updateBrand = (data: UpdateBrand) =>
  fetchAPI("/admin/update/brand", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const addWalletBalance = (data: AddWalletBalance) =>
  fetchAPI("/wallet/add/balance", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const updateWalletBalance = (data: UpdateWalletBalance) =>
  fetchAPI("/wallet/update", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const fetchOrderDetails = (orderNo: string) =>
  fetchAPI(`/order/view/${orderNo}`);

export const fetchCartDetails = (phoneNumber: string) =>
  fetchAPI(`/bulkOrder/cart/fetch/${phoneNumber}`);

export const fetchProductDetails = async (prod_ID: string) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_BASE_URL_FETCH}/product/${prod_ID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch product details: ${response.statusText}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching product details:", error);
    throw error;
  }
};

export const addBulkOrderUser = (data: AddBulkOrderUser) =>
  fetchAPI("/admin/bulkOrder_user/add", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const updateOrderStatus = (data: UpdateOrderStatus) =>
  fetchAPI("/admin/Order/Status", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const updateInvoice = (data: UpdateInvoiceProps) =>
  fetchAPI("/admin/Shipping/update", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const addProduct = (data: AddProduct) =>
  fetchAPI("/products", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const activateCredit = (data: CreditActivationData) =>
  fetchAPI("/credit/add", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const addCoupon = (data: CouponData) =>
  fetchAPI("/coupon/add", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const checkPhoneNumber = async (phoneNumber: string) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_BASE_URL_FETCH}/fetch/user/${phoneNumber}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch Phone Number Status: ${response.statusText}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Phone Number Status:", error);
    throw error;
  }
};

export const registerPhoneNumber = async (phoneNumber: string) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_B2B_API_BASE_URL}/signup/user/${phoneNumber}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch Phone Number Register: ${response.statusText}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Phone Number Register:", error);
    throw error;
  }
};

export const fetchWalletDetail = async (userID: number) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_B2B_API_BASE_URL}/wallet/${userID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch Phone Number Register: ${response.statusText}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Phone Number Register:", error);
    throw error;
  }
};
